// extracted by mini-css-extract-plugin
module.exports = {"markContainer":"Markdown_markContainer__3MK-0","markInput":"Markdown_markInput__1KfKo","displayMobile":"Markdown_displayMobile__PfETZ"};